import { Tooltip, Typography } from '@mui/material';
import { FC } from 'react';
import { usePlayerContext } from '../PlayerContext';
import { formatTime } from '../../../helpers';
import { useTranslation } from 'react-i18next';

type TimePresentationProps = {
  position: number;
  duration: number;
  lookback: number;
  onJumpLive(): void;
};

export const TimePresentation: FC<TimePresentationProps> = ({ position, duration, lookback, onJumpLive }) => {
  const { player } = usePlayerContext();
  const { t } = useTranslation();

  const isLive = lookback <= 5;

  return (
    <Typography color="white" variant="p16Medium" sx={{ fontFeatureSettings: `'tnum'` }}>
      {player?.isLive() ? (
        isLive ? (
          t('player.controls.live')
        ) : (
          <Tooltip title={t('player.controls.jumplive')} placement="top">
            <span role="button" style={{ cursor: 'pointer' }} onClick={onJumpLive}>
              -{formatTime(lookback)}
            </span>
          </Tooltip>
        )
      ) : (
        <>
          {formatTime(position)} / {formatTime(duration)}
        </>
      )}
    </Typography>
  );
};
